const INITIAL_STATE = { list: [], parcelas: [], cliente: {} }

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CARNE_FETCHED':
            return { ...state, list: action.payload.data }
        case 'CARNE_SEARCH_PARC':
            return { ...state, parcelas: action.payload.data.parcelas, cliente: action.payload.data.cliente }

        case 'CARNE_CLEAR_FORM_CREAT':
            return { ...state, parcelas: [], cliente: {} }
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/carne/carneReducer.js